module.exports = __webpack_public_path__ + "static/media/endosee-ifu-document@2x.e6e8b774.jpg";